import React from "react";
import { JobImg } from "../assets";

const About = () => {
  return (
    <div className='container mx-auto flex flex-col gap-8 2xl:gap-14 py-6 '>
      <div className='w-full flex flex-col-reverse md:flex-row gap-10 items-center p-5'>
        <div className='w-full md:2/3 2xl:w-2/4'>
          <h1 className='text-3xl text-blue-600 font-bold mb-5'>About Us</h1>
          <p className='text-justify leading-7'>
          Mr. Aashish Timsin, a visionary developer,
           has dedicated his expertise to creating a
            job searching platform tailored for the Nepali people.
             This innovative platform aims 
          to simplify the job search process for individuals in Nepal,
           making it more accessible and efficient.
          </p>
        </div>
        <img src={JobImg} alt='About' className='w-auto h-[300px]' />
      </div>

      <div className='leading-8 px-5 text-justify'>
        <p>Aashish's commitment to leveraging technology to address local challenges 
          is evident in this project. He has meticulously designed the platform to 
          cater to the specific needs of the Nepali job market, ensuring that it is 
          user-friendly and intuitive. The platform is equipped with advanced search functionalities, allowing users to filter job listings by various criteria such as job type, experience level, and location. This feature not only enhances the user experience but also helps job seekers find the most relevant opportunities more quickly.</p>
      </div>
      <div className="leading-8 px-5 text-justify">
      Moreover, Aashish has incorporated a comprehensive job posting system, enabling companies to easily list their vacancies. This feature is designed to facilitate communication between employers and job seekers, making the hiring process smoother and more efficient. The platform also includes a detailed profile section for companies, providing potential candidates with valuable insights into the organization's culture, values, and the types of projects they undertake.
      </div>
      <div className="leading-7 px-4 text-justify">
      Aashish's dedication to making job searching easier for the Nepali people is commendable. By creating a platform that not only simplifies the job search process but also promotes local businesses, he is contributing significantly to the economic growth and development of Nepal. His work is a testament to the power of technology in addressing societal challenges and improving the lives of individuals.


      </div>
    </div>
  );
};

export default About;
